module.exports = __webpack_public_path__ + "static/product.yett-3774c19b0fc0dda6ecfe388490064878.png";